import { render, staticRenderFns } from "./MobileTextarea.vue?vue&type=template&id=2357ae42&scoped=true"
import script from "./MobileTextarea.vue?vue&type=script&lang=js"
export * from "./MobileTextarea.vue?vue&type=script&lang=js"
import style0 from "./MobileTextarea.vue?vue&type=style&index=0&id=2357ae42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2357ae42",
  null
  
)

export default component.exports